import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';

const ContactUsPopoverContent = () => {
  return (
    <Container>
      <div className='header-container'>
        <Text variant='H7' textTransform='uppercase'>
          Contact Us
        </Text>
      </div>

      <div className='body-container'>
        {/* <div className='body-container-item'>
          <div>
            <Text variant='H8' className='body-container-item-content'>
              Rep Direct: A.Thanh
            </Text>
          </div>
          <Text variant='H9' textTransform='capitalize'>
            (904) 343-1046
          </Text>
        </div> */}
        <div className='body-container-item'>
          <div>
            <Text variant='H8' className='body-container-item-content'>
              Team Leader: A.Toàn
            </Text>
            <Text variant='H8' className='body-container-item-content' color='text_4_v2'>
              Quick service
            </Text>
          </div>
          <Text variant='H9' textTransform='capitalize'>
            (904) 444-3333
          </Text>
        </div>
        <div className='body-container-item'>
          <Text variant='H8' className='body-container-item-content'>
            Team support
          </Text>
          <Text variant='H9' textTransform='capitalize'>
            (800) 912-0503
          </Text>
        </div>
        <div className='body-container-item'>
          <div>
            <Text variant='H8' className='body-container-item-content'>
              Credit card processing
            </Text>
            <Text variant='H8' className='body-container-item-content' color='text_4_v2'>
              24/7
            </Text>
          </div>
          <Text variant='H9' textTransform='capitalize'>
            (800) 789-8897
          </Text>
        </div>
      </div>
    </Container>
  );
};

export default ContactUsPopoverContent;

const Container = styled.div`
  display: flex;
  width: 512px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: var(--Neutral-02, #f6f7fc);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);

  .header-container {
    display: flex;
    padding: 16px 8px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
  .body-container {
    display: flex;
    padding: 0px 8px 24px 8px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    .body-container-item:nth-child(odd) {
      background: #fff;
    }
    .body-container-item:nth-child(even) {
      background: #f6f7fc;
    }
  }
  .body-container-item {
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
  .body-container-item-content {
    font-weight: 500;
  }
`;
